<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title">{{ title }}</div>
    <div class="moat-list container">
      <div class="button-container pt-1 pb-1">
        <div class="button-left">
            <div class="pr-2">
                <a href="#" @click="displayDeleteConfirmation(deleteMoatInitiatives,this.moatInitiativeIdsToDelete,'Delete Moat Initiatives','Are you sure you want delete the selected moat initiatives ?')">
                <button type="button" class="btn btn-primary delete-card" id="DeleteMoatInitiative" :disabled="!deleteCardButtonEnabled">
                    Delete Rows 
                    <span class="ml-auto">
                    <font-awesome-icon :icon="['fa', 'minus-circle']" />
                    </span>
                </button>
                </a>
            </div>
        </div>
        <div class="button-right">
          <a class="pr-2" href="#" @click="$modal.show('import-moat-data-file')">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Import Moat Initiative <font-awesome-icon :icon="['fas', 'upload']"/></span>
            </button>
          </a>
          <a href="/api/v1/admin/download-moat-initiative-import-template" @click.prevent="downloadItem()" id="DownloadMoatImportTemplate">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Download Moat Initiative Template <font-awesome-icon :icon="['fa', 'download']"/></span>
            </button>
          </a>
        </div>
      </div>

      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
    </div>
    <vue-modal ref="import-moat-data-file" name="import-moat-data-file" :width="368" :height="400">
      <div class="container">
        <div class="form-group form-row p-2">
          <h5 class="font-weight-bold">Import Moat Initiative Data</h5>
        </div>
        <div class="form-group form-row p-2">
          {{ returnMessage }}
        </div>
        <div class="form-group form-row">
          <span class="pr-2">Select a file to upload</span>
          <input ref="importMoatFileUpload" type="file" @change="onFileChange" />
        </div>
        <div class="form-group form-row d-flex justify-content-end">
          <button type="submit" class="btn btn-primary float-right ml-2" v-on:click="this.importFile">
            <span>Import File</span>
            <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
          </button>
          <button
            type="button"
            class="btn btn-primary ml-4"
            @click="closeModal"
          >
            Close
          </button>
        </div>
      </div>
    </vue-modal>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";
import moment from "moment";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import AdminService from "../../services/admin.service";
import MoatService from "../../services/moat.service";

export default {
  name: "MoatInitiative",
  mixins: [AdminMixins, DataTableMixins],
  components: {},
  data() {
    return {
      importMoatDataImportFile: "",
      returnMessage: "",
      title: "Moat Initiative",
      moatInitiativeIdsToDelete: [],
      table: {
        id: "moat-initiative-table",
        columns: MoatService.getMoatInitiativeTableColumnData(),
        configuration: {
          searching: true,
          responsive: false,
          dom: 'B<"top"if>rt<"bottom"lp><"clear">',
          paging: true,
          destroy: true,
          info: true,
          ordering: true,
          keys: true,
          bSort: false,
          pageLength: 50,  
        }
      },
    };
  },
  methods: {
    async getTableData() {
      this.$root.processServerRequest("Loading table data");
      MoatService.getMoatInitiativeDataList(this.getMoatInitiativeTableDataCallback, this);
    },
    getMoatInitiativeTableDataCallback(response) {
      this.$root.processServerResponse();
      this.table.data = response.data.data;
      this.setupTable();
      this.setupRowClick();
    },
    getDownloadFilename() {
      return "Moat Initiative Import Template";
    },
    onFileChange: function() {
      this.importMoatDataImportFile = this.$refs.importMoatFileUpload.files[0];
    },
    async importFile() {
      this.$root.processServerRequest("Importing moat initiatives");
      this.setModalLoading(true);
      MoatService.importMoatInitiativeData(this.importMoatDataImportFile, this.importFileCallback, this);
    },
    importFileCallback: function(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);

      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.returnMessage = response.data.message;
        this.closeModal();
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    closeModal: function() {
      if (this.$refs['import-moat-data-file'] != null) {
        this.$refs['import-moat-data-file'].visible = false;
      }
      this.$router.go(0);
    },
    setupRowClick() {
        const vm = this;
        if( this.table.dataTable.click == undefined)  {

            this.table.dataTable.on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
                var $row = $(this).closest("tr");
                var data = vm.table.dataTable.row($row).data();
                if (!$.isEmptyObject(data)) {
                    if (e.target.checked) {
                        if (!vm.moatInitiativeIdsToDelete.includes(data.moatInitiativeId)){
                            vm.moatInitiativeIdsToDelete.push(data.moatInitiativeId);
                        }
                    } else {
                        var match = vm.moatInitiativeIdsToDelete.find(x => x === data.moatInitiativeId);
                        if (typeof match !== "undefined") {
                            vm.moatInitiativeIdsToDelete.splice($.inArray(match, vm.moatInitiativeIdsToDelete), 1);
                        }
                    }
                }
            });
        }
    },
    async deleteMoatInitiatives(result) {
        MoatService.deleteMoatInitiatives(this.moatInitiativeIdsToDelete,this.deleteMoatInitiativesCallback,this);
    },
    deleteMoatInitiativesCallback(response) {
        this.$root.processServerResponse();
        let statusCode = response.data.statusCode;
        if (statusCode == 200) {
            AdminService.displaySuccessMessage({ text: response.data.message });
            this.moatInitiativeIdsToDelete = [];
            this.getTableData();
        } else {
            AdminService.displayErrorMessage({ text: response.data.message });
        }
    },       
  },
  computed: {
    downloadItemUrl: function() {
      return this.baseUrl + "/api/v1/admin/download-moat-initiative-import-template";
    },
    deleteCardButtonEnabled: function(){
        return this.moatInitiativeIdsToDelete.length > 0;
    },
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      this.table.configuration.order = [
        [1, "asc"]
      ];
    }
  },
  props: {},
  mounted() {}
};
</script>
